import { Socket } from "socket.io-client"
import { ModalityDataSource } from "../Types/ModalityDataSource"
import { ImagePage } from "./ImagePage"
import { PersystImagePageProperties } from "./PersystPageManager"

type PersystTrendsImagePageProperties = PersystImagePageProperties & {
	isArtifactReductionEnabled: boolean
}

export class PersystTrendsImagePage extends ImagePage<PersystTrendsImagePageProperties> {
	public recordingStartTime: number = 0
	public isArtifactReductionEnabled = false
	
    socketEventName = () => "render_persyst_trend"

	getRenderSettings = () => ({
		height: this.height,
		width: this.width,
		isArtifactReductionEnabled: this.isArtifactReductionEnabled,
	})

    requestData(batch: Map<number, ModalityDataSource[]>, socket: Socket): void {
		if (this.getDataQuerySocket === null) {
			return
		}

		let relativeStartTimeSeconds = Math.round(Math.max(0, this.startTime - this.recordingStartTime) / 1000)

		if (this.recordingStartTime === 0) {
			relativeStartTimeSeconds = 0
		}
		
		batch.forEach((modalities, dataObjectId) => {
			socket.emit(
				this.socketEventName(), 
				this.patientId, 
				dataObjectId, 
				this.id,
				modalities[0],
				this.startTime,
				this.endTime,
				this.width,
				this.height,
				relativeStartTimeSeconds,
				this.isArtifactReductionEnabled,
				this.getSettingsHash()
			)
		})
    }
}